<template>
  <hc-base-upload
    ref="hcBaseUploadRef"
    :hcCaseFlightFileType="hcCaseFlightFileType"
    :hcCaseMasterId="hcCaseMasterId"
    :validateUploadFileOptions="validateUploadFileOptions"
    :objectType="objectType"
    @downloadFile="downloadFile"
  ></hc-base-upload>
</template>

<script>
import downloadService from "../../../services/downloadService";
import FileTypeImage from "../../job/FileTypeImage";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import HcBaseUpload from "./hc-base-upload";
import hcCaseHotelService from "../../../services/khachsan/hcCaseHotelService";

export default {
  name: "hc-ks-upload",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: { HcBaseUpload, FileTypeImage },
  props: ["hcCaseFlightFileType", "id"],

  data() {
    return {
      isUploadingFlag: false,
      uploadAdditionalData: { objectType: null },
      vbAttachments: [],
      fieldTitle: null,
      hcCaseHotel: null,
      hcCaseFlightFiles: [],
      hcCaseMasterId: null,
      validateUploadFileOptions: null,
      objectType: null
    };
  },

  watch: {
    id() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    initCommon() {
      this.objectType = hanhChinhUtils.getVbAttachmentObjectTypeByHcCaseFlightFileType(
        this.hcCaseFlightFileType
      );
      this.validateUploadFileOptions = hanhChinhUtils.initMayBayFileValidateFileOptions(
        this.hcCaseFlightFileType
      );
    },

    loadHcCaseHotel() {
      return hcCaseHotelService.findById(this.id).then(response => {
        this.hcCaseHotel = response.data;
        this.hcCaseMasterId = this.hcCaseHotel.caseMasterId;
        console.log(this.hcCaseMasterId);
      });
    },

    initFieldTitle() {
      this.fieldTitle = hanhChinhUtils.initHcCaseFlightFilesFieldTitle(
        this.hcCaseFlightFileType
      );
    },

    getData() {
      return this.$refs.hcBaseUploadRef.getData();
    },

    downloadFile(event) {
      let hcCaseFlightFileId = event.hcCaseFlightFileId;
      let vbAttachmentId = event.vbAttachmentId;
      downloadService.downloadFileForHcCaseFlightFile(
        this.id,
        hcCaseFlightFileId,
        vbAttachmentId
      );
    },

    async reloadData() {
      this.initCommon();
      if (this.id) {
        await this.loadHcCaseHotel();
      }
    }
  }
};
</script>

<style scoped>
.download-icon:hover {
  color: var(--color-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-upload.vue